'use client'

import { Image, Spacer, Text } from '@vinted/web-ui'
import { useEffect } from 'react'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { useTranslate } from '@marketplace-web/i18n/i18n-feature'
import { useAsset } from '@marketplace-web/shared/assets'
import { viewScreenEvent } from '@marketplace-web/business-accounts/business-accounts-data'

const FailedState = () => {
  const { track } = useTracking()
  const translate = useTranslate('business.wallet.status.failed')
  const asset = useAsset('/assets/kyc')

  useEffect(() => {
    track(
      viewScreenEvent({
        screen: 'wallet_conversion',
      }),
    )
  }, [track])

  return (
    <div className="u-flexbox u-flex-direction-column u-align-items-center">
      <Image
        src={asset('cross.svg', { theme: { dark: 'dark/cross.svg' } })}
        size={Image.Size.X2Large}
      />
      <Spacer size={Spacer.Size.XLarge} />
      <Text
        as="h1"
        type={Text.Type.Heading}
        alignment={Text.Alignment.Center}
        text={translate('title')}
      />
      <Spacer />
      <Text as="span" alignment={Text.Alignment.Center} html text={translate('body')} />
    </div>
  )
}

export default FailedState
